class SessionDetailDto {

    CustomerName: string;
    WorkspaceName: string;
    SubscriptionEnd: Date | null;
    Role: number;
    UserIsMultiCustomer: boolean;
    WithMetaAPI: boolean;
    EnterpriseMode: boolean;
    WithInternalAIAssistant: boolean;
    WithCustomerAIAssistant: boolean;
    WithAutoMapping: boolean;
    WithAdvancedCustomerCredentials: boolean;
    WithPortal: boolean;
    WithFilterVisibility: boolean;
    WithGlobalSettings: boolean;
    WithWorkspaceSettings: boolean;
    WithSso: boolean;

    NotificationMessage: string;
    NotificationClass: string;

    constructor(customerName: string, workspaceName: string, subscriptionEnd: Date | null, role: number, userIsMultiCustomer: boolean, withMetaAPI: boolean, enterpriseMode: boolean, withInternalAIAssistant: boolean, withCustomerAIAssistant: boolean, withAutoMapping: boolean, withAdvancedCustomerCredentials: boolean, withPortal: boolean, withFilterVisibility: boolean, withGlobalSettings: boolean, withWorkspaceSettings: boolean, withSso: boolean) {
        this.CustomerName = customerName;
        this.WorkspaceName = workspaceName;
        this.SubscriptionEnd = subscriptionEnd;
        this.Role = role;
        this.UserIsMultiCustomer = userIsMultiCustomer;
        this.WithMetaAPI = withMetaAPI;
        this.EnterpriseMode = enterpriseMode;
        this.WithInternalAIAssistant = withInternalAIAssistant;
        this.WithCustomerAIAssistant = withCustomerAIAssistant;
        this.WithAutoMapping = withAutoMapping;
        this.WithAdvancedCustomerCredentials = withAdvancedCustomerCredentials;
        this.WithPortal = withPortal;
        this.WithFilterVisibility = withFilterVisibility;
        this.WithGlobalSettings = withGlobalSettings;
        this.WithWorkspaceSettings = withWorkspaceSettings;
        this.WithSso = withSso;

        this.NotificationMessage = "";
        this.NotificationClass = "";

        if (subscriptionEnd !== null) {
            const now = new Date();
            if (subscriptionEnd > now) {
                const daysRemaining = Math.ceil(
                    (subscriptionEnd.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
                );
                if (daysRemaining < 15) {
                    this.NotificationMessage = `The end of your subscription is in ${daysRemaining} day${daysRemaining > 1 ? 's' : ''}`;
                    this.NotificationClass = "notification-orange";
                }
            } else {
                this.NotificationMessage = "Your subscription has ended. Please see the billing section to renew.";
                this.NotificationClass = "notification-red";
            }
        }
    }
}

export default SessionDetailDto;
